import React from 'react';
import { FaTimes } from 'react-icons/fa';
import Table from '../common/components/table';

export const CollectionModalComponet = ({ isModalProductOpen,isModalOpen,handleCloseModal,categoryColumnData, categoryRowData , setPageData,
    handleCloseProductModal, categoriesPaginationData,onSelect,additionButtons,productColumnData,productRowData,productsPaginationData
 }: any) => (
    <>
   {isModalOpen && (
  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded shadow-lg w-[1000px] max-h-[80vh] overflow-hidden">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold mb-4">Add Categories</h2>
        <button onClick={handleCloseModal} className="text-gray-500 hover:text-gray-700">
          <FaTimes className="w-6 h-6" />
        </button>
      </div>
      <div className="overflow-y-auto max-h-[70vh]">
        <Table
          columnData={categoryColumnData}
          rowData={categoryRowData}
          setPageData={setPageData}
          categoriesPaginationData={categoriesPaginationData}
          onSelect={onSelect}
          additionButtons={additionButtons}
        />
      </div>
    </div>
  </div>
)}
      {isModalProductOpen && (
        <div className="fixed inset-0 ml-80 mt-40 flex w-[1000px] h-[400px] items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-lg w-full overflow-y-auto">
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-bold mb-4">Add Products</h2>
              <button onClick={handleCloseProductModal} className="text-gray-500 hover:text-gray-700">
                <FaTimes className="w-6 h-6" />
              </button>
            </div>
            <Table
              columnData={productColumnData}
              rowData={productRowData}
              setPageData={setPageData}
              paginationData={productsPaginationData}
              headingName="Products"
              onSelect={onSelect} 
              additionButtons={additionButtons}
            />
          </div>
        </div>
      )} 
    </>
)